(() => {
  if (window.__WN_NAMI_NORTHSTAR_STORY_V1__) return;
  window.__WN_NAMI_NORTHSTAR_STORY_V1__ = true;

  const scrollToPurchase = finish => {
    const main = document.querySelector('.wn-nami-northstar');
    if (!main) return;

    if (finish) {
      const option = [...main.querySelectorAll('[data-option-value]')]
        .find(node => node.dataset.optionValue?.toLowerCase() === finish.toLowerCase());
      option?.click();
    }

    const form = main.querySelector('.wn-nami-scene__form, .wn-nami-northstar__form');
    (form || main).scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center'
    });
  };

  document.addEventListener('click', event => {
    const finish = event.target.closest('[data-nami-finish]');
    if (finish) {
      scrollToPurchase(finish.dataset.namiFinish);
      return;
    }

    if (event.target.closest('[data-nami-scroll-purchase]')) scrollToPurchase();
  });
})();